import {remCalc} from '_themeUtils'

const crossCategoryNavigation = {
    CrossCategoryNavigation: {
        baseStyle: () => ({
            wrapper: {
                w: '100%',
                h: remCalc(48),
                backgroundColor: 'color.background.grey.100',
                px: {base: 'spacing.4', md: 0},
            },
            container: {
                w: '100%',
                h: '100%',
                justifyContent: {base: 'space-evenly', md: 'center'},
                alignItems: 'center',
                gap: {base: remCalc(16), md: remCalc(32)},
                overflow: 'auto',
            },
            link: {
                textStyle: 'paragraphXs',
                textTransform: 'uppercase',
                letterSpacing: remCalc(2.4),
                fontWeight: 300,
                whiteSpace: 'nowrap',
            },
        }),
        variants: {
            top: {
                wrapper: {
                    mb: {base: 0, md: 'spacing.12'},
                },
            },
            bottom: {
                wrapper: {
                    mt: {base: 'spacing.3', md: 'spacing.6'},
                    mb: {base: 'spacing.12', md: 'spacing.12'},
                },
            },
        },
    },
}

export default crossCategoryNavigation
